import { render, staticRenderFns } from "./AutoCompleteClinicalTables.vue?vue&type=template&id=ec3cf6fa&"
import script from "./AutoCompleteClinicalTables.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteClinicalTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports